import { styled } from 'styled-components';

import { colors, gutterWidth } from 'theme/theme';

export const MobileSearchMenuHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: ${colors.white};
  z-index: 104;
`;

export const MobileSearchMenuHeader = styled.div`
  align-items: center;
  background: ${colors.white};
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0 ${gutterWidth / 2}px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid ${colors.selectionGrey};
`;

export const MobileSearchMenuBody = styled.div`
  padding: 36px ${gutterWidth / 2}px;
`;

export const MobileSearchMenuForm = styled.form<{
  $isTabbing?: boolean;
}>`
  --page-header-search-gap: 12px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--page-header-search-gap);
  padding: 0;
  font-size: 18px;
`;

export const MobileSearchMenuButtonWrapper = styled.div`
  padding-block-start: calc(40px - var(--page-header-search-gap));
`;
